import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTPICKUPLOCATIONBLOCK_LEGACY_FIELD_ORDER = [];

const {
  cartPickupLocationBlockDescriptor: _generatedCartPickupLocationBlockDescriptor,
  cartPickupLocationBlockBlocDefinition,
  cartPickupLocationBlockDashboardLayout,
  cartPickupLocationBlockConfig,
  cartPickupLocationBlockResolveConfig,
  cartPickupLocationBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart - Pickup location",
    componentType: 'CartPickupLocationBlockComponent',
    category: 'cart',
    description: "Cart - Pickup location.",
    keywords: [],
    allowedIn: [
      { bloc: 'CartPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function cartPickupLocationBlockDescriptor(): IBlockDescriptor;
export function cartPickupLocationBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartPickupLocationBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartPickupLocationBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartPickupLocationBlockDescriptor, cartPickupLocationBlockProperties, fieldOrder);
}

export {
  cartPickupLocationBlockBlocDefinition,
  cartPickupLocationBlockDashboardLayout,
  cartPickupLocationBlockProperties,
  cartPickupLocationBlockConfig,
  cartPickupLocationBlockResolveConfig,
};

export type CartPickupLocationBlockConfig = typeof cartPickupLocationBlockConfig;
